const FALLBACK_MESSAGE = 'Page not found'

// Not isPlainObject: it rejects Error instances
const isReadable = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

const readString = (source: unknown, key: string): string | undefined => {
  if (!isReadable(source)) return undefined
  const value = source[key]
  return typeof value === 'string' && value.trim() ? value : undefined
}

// Checked reads: axios may leave an XHR in .response
export const getRouteErrorMessage = (error: unknown): string => {
  if (!isReadable(error)) return FALLBACK_MESSAGE
  const fromResponse = isReadable(error.response)
    ? readString(error.response.data, 'message')
    : undefined
  return fromResponse ?? readString(error, 'message') ?? FALLBACK_MESSAGE
}
